import React from 'react';
import {FormField} from "semantic-ui-react";
import NumberInput from "../../../controls/numberInput";
import Info from "../../../components/Info";

const DocParams = ({changeParam, form, errors, disabled, field}) => {
    return <div className='d-flex inputs doc-params'>
        <FormField error={errors['documentWeight']}>
            <label>
                Вес, кг*
                <Info
                    name={'Вес, кг'}
                    text={'0,5 кг - это примерно 100 стандартных листов А4, отправка в пластиковом конверте. 0,2 кг - стандартный пакет для документов курьерской компании'}
                />
            </label>
            <NumberInput
                disabled={disabled}
                error={errors['documentWeight']}
                id="inputWeight"
                value={form.documentWeight}
                onChange={value => changeParam("documentWeight", value)}
                decimals="5"
                min="0"
                step={0.1}
            />
        </FormField>
        {field && field}
    </div>
}

export default DocParams;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/docParams.jsx